import { useEffect, useMemo } from 'react';
import { getRequiredDocuments, selectDocumentsIsLoading, selectRequiredDocuments } from '../feature';
import { useAppDispatch, useAppState } from '@/store';
import { PropertyType } from '@/models/property.model';

export const useGetRequiredDocuments = (propertyType: string = PropertyType.TOWNHOUSE) => {
  const dispatch = useAppDispatch();
  const { requiredDocuments, totalRequiredDocuments } = useAppState(selectRequiredDocuments);
  const isLoading = useAppState(selectDocumentsIsLoading);

  useEffect(() => {
    dispatch(
      getRequiredDocuments({
        property_type: propertyType as PropertyType,
      }),
    );
  }, [propertyType]);

  return useMemo(
    () => ({ requiredDocuments, totalRequiredDocuments, isLoading }),
    [requiredDocuments, totalRequiredDocuments, isLoading],
  );
};
